module.exports = __webpack_public_path__ + "img/icon_category_04_w.109c6195.svg";